import { PropsWithChildren, useEffect } from 'react';
import withRouter from './Common/withRouter';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from "reselect";
import { changeLayoutMode } from "../store/layout/actions";

const NonAuthLayout = (props: PropsWithChildren) => {
  const dispatch = useDispatch();
  const LayoutModeProperties = createSelector(
    (state) => state.Layout,
    (layout) => ({
      layoutModeType: layout.layoutModeType,
    })
  );

  const {
    layoutModeType
  } = useSelector(LayoutModeProperties);

  useEffect(() => {
    if (layoutModeType) {
      dispatch(changeLayoutMode(layoutModeType));
    }
  }, [layoutModeType, dispatch]);

  return (
    <div style={{backgroundColor: "#000", minHeight: "100vh"}}>
      {props.children}
    </div>
  );
};

export default withRouter(NonAuthLayout);
